<template>
    <div>
        <Head title="Contact" />
        <!-- Start Hero -->
        <section class="relative table w-full py-20 lg:py-24 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 text-center mt-10">
                    <h3 class="text-3xl leading-normal font-semibold">{{ __(data.title) }}</h3>
                </div><!--end grid-->
            </div><!--end container-->
        </section><!--end section-->
        <div class="relative">
            <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-white dark:text-slate-900">
                <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- End Hero -->

        <!-- Start Section-->
        <section class="relative md:py-24 py-16">
            <div class="container">
                <div class="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-[30px]">
                    <div class="text-center px-6 mt-6">
                        <div class="w-20 h-20 bg-indigo-600/5 text-indigo-600 rounded-xl text-3xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 mx-auto">
                            <icon class="h-8 w-8 fill-indigo-600" name="phone" />
                        </div>

                        <div class="content mt-7">
                            <h5 class="title h5 text-xl font-medium">Phone</h5>
                            <p class="text-slate-400 mt-3">{{ page.phone_details }}</p>

                            <div class="mt-5">
                                <a href="tel:+152534-468-854" class="btn btn-link text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">{{ page.phone }}</a>
                            </div>
                        </div>
                    </div>

                    <div class="text-center px-6 mt-6">
                        <div class="w-20 h-20 bg-indigo-600/5 text-indigo-600 rounded-xl text-3xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 mx-auto">
                            <icon class="h-8 w-8 fill-indigo-600" name="email" />
                        </div>

                        <div class="content mt-7">
                            <h5 class="title h5 text-xl font-medium">Email</h5>
                            <p class="text-slate-400 mt-3">{{ page.email_details }}</p>

                            <div class="mt-5">
                                <a href="mailto:contact@example.com" class="btn btn-link text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">{{ page.email }}</a>
                            </div>
                        </div>
                    </div>

                    <div class="text-center px-6 mt-6">
                        <div class="w-20 h-20 bg-indigo-600/5 text-indigo-600 rounded-xl text-3xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 mx-auto">
                            <icon class="h-8 w-8 fill-indigo-600" name="location" />
                        </div>

                        <div class="content mt-7">
                            <h5 class="title h5 text-xl font-medium">Location</h5>
                            <p class="text-slate-400 mt-3" v-html="sanitizeHtml(page.location)"></p>

                            <div class="mt-5">
                                <a href="{{ page.location_map }}"
                                   data-type="iframe" class="video-play-icon read-more lightbox btn btn-link text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500 ease-in-out">View on Google map</a>
                            </div>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->

            <div class="container md:mt-24 mt-16">
                <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                    <div class="lg:col-span-7 md:col-span-6">
                        <img src="landing/images/svg/contact-bg.svg" alt="">
                    </div>

                    <div class="lg:col-span-5 md:col-span-6 mt-8 md:mt-0">
                        <div class="lg:ml-5">
                            <div class="bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800 p-6">
                                <h3 class="mb-6 text-2xl leading-normal font-medium">Get in touch !</h3>

                                <form method="post" @submit.prevent="store">
                                    <p class="mb-0" id="error-msg"></p>
                                    <div id="simple-msg"></div>
                                    <div class="grid lg:grid-cols-12 lg:gap-6">
                                        <div class="lg:col-span-6 mb-5">
                                            <div class="text-left">
                                                <label for="name" class="font-semibold">Your Name</label>
                                                <div class="form-icon relative mt-2">
                                                    <icon class="w-4 w-4 absolute top-3 left-4 z-1" name="user" />
                                                    <input name="name" id="name" v-model="form.name" type="text" class="form-input pl-11" placeholder="Name">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="lg:col-span-6 mb-5">
                                            <div class="text-left">
                                                <label for="email" class="font-semibold">Your Email</label>
                                                <div class="form-icon relative mt-2">
                                                    <icon class="w-4 w-4 absolute top-3 left-4 z-1" name="email" />
                                                    <input name="email" id="email" type="email" v-model="form.email" class="form-input pl-11" placeholder="Email">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="grid grid-cols-1">
                                        <div class="mb-5">
                                            <div class="text-left">
                                                <label for="subject" class="font-semibold">Your Question</label>
                                                <div class="form-icon relative mt-2">
                                                    <icon class="w-4 w-4 absolute top-3 left-4 z-1" name="book" />
                                                    <input name="subject" id="subject" v-model="form.question" class="form-input pl-11" placeholder="Question">
                                                </div>
                                            </div>
                                        </div>

                                        <div class="mb-5">
                                            <div class="text-left">
                                                <label for="comments" class="font-semibold">Your Message</label>
                                                <div class="form-icon relative mt-2">
                                                    <icon class="w-4 w-4 absolute top-2 left-4 z-1" name="email" />
                                                    <textarea name="comments" id="comments" v-model="form.message" class="form-input pl-11 h-28" placeholder="Message :"></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <button type="submit" id="submit" name="send" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md justify-center flex items-center">Send Message</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!--end container-->
        </section><!--end section-->
        <!-- End Section-->

        <div class="container-fluid relative">
            <div class="grid grid-cols-1">
                <div class="w-full leading-[0] border-0">
                    <iframe :src="page.location_map" style="border:0" class="w-full h-[500px]" allowfullscreen></iframe>
                </div>
            </div><!--end grid-->
        </div><!--end container-->
    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import { Head } from '@inertiajs/inertia-vue3'
import sanitizeHtml from "sanitize-html";
export default {
    layout: Layout,
    components: {
        Icon,
        Head,
    },
    props: {
        data: Object,
    },
    data() {
        return {
            page: JSON.parse(this.data.html),
            form: this.$inertia.form({
                name: '',
                email: '',
                question: '',
                message: '',
            }),
        }
    },
    methods:{
        sanitizeHtml : sanitizeHtml,
        store() {
            this.form.post(this.route('contact.send'),{
                onSuccess: () => {
                    this.form.reset()
                },
            })
        },
    }
}
</script>
